import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  useDisclosure,
  FormControl,
  FormLabel,
  Checkbox,
  ModalOverlay,
} from '@chakra-ui/react';
import { submitFeedback } from '../../utils/api'; // Replace './api' with the correct path to your api.js file
import toast from 'react-hot-toast';
import { useLocation } from 'react-router-dom';

const Feedback = () => {
  const [likes, setLikes] = useState([]);
  const [improvements, setImprovements] = useState([]);
  const [additionalFeedback, setAdditionalFeedback] = useState('');
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const location = useLocation(); // Import useLocation hook

  useEffect(() => {
    if (
      location.pathname === '/portfolio' && // Check if the current path is '/portfolio'
      (!localStorage.getItem('portfolioLastSeen') || Date.now() - parseInt(localStorage.getItem('portfolioLastSeen'), 10) > 2 * 60 * 60 * 1000)
    ) {
      setTimeout(() => {
        setModalVisible(true);
      }, 10000); // Delay the modal show by 10 seconds
      localStorage.setItem('portfolioLastSeen', Date.now());
    }
  }, [location.pathname]); // Watch for changes to the pathname
  

  const handleModalClose = () => {
    setModalVisible(false);
  };

  const handleLikesChange = (event) => {
    const { value } = event.target;
    if (likes.includes(value)) {
      setLikes(likes.filter((item) => item !== value));
    } else {
      setLikes([...likes, value]);
    }
  };

  const handleImprovementsChange = (event) => {
    const { value } = event.target;
    if (improvements.includes(value)) {
      setImprovements(improvements.filter((item) => item !== value));
    } else {
      setImprovements([...improvements, value]);
    }
  };

  const handleAdditionalFeedbackChange = (event) => {
    setAdditionalFeedback(event.target.value);
  };

  const handleSubmit = async () => {
    try {
      // Check if additionalFeedback is empty
      if (!additionalFeedback.trim()) {
        toast.error('Please provide additional feedback.');
        return;
      }
      setLoading(true); // Set loading state to true before API call
      const feedbackData = {
        likes,
        improvements,
        additionalFeedback,
      };
      await submitFeedback(feedbackData);
      setLoading(false); // Set loading state to false after API call
      toast.success('Feedback submitted successfully!');
      setTimeout(() => {
        handleModalClose(); // Close the modal after successful submission
      }, 500); // Delay the modal close by 2 seconds
    } catch (error) {
      console.error('Error submitting feedback:', error.message);
      toast.error('Error submitting feedback.');
      setLoading(false); // Set loading state to false in case of an error
    }
  };

  return (
    <Modal isCentered isOpen={modalVisible} onClose={handleModalClose} size='lg'>
       <ModalOverlay bg='blackAlpha.300' backdropFilter='blur(10px) hue-rotate(90deg)' />
      <ModalContent bg="#1F2937" color="white" borderRadius="8px">
        <ModalHeader>Feedback</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb="4">Thank you for visiting! We would love to hear your feedback:</Text>
          <FormControl as="fieldset">
            <FormLabel as="legend">What do you like about my portfolio?</FormLabel>
            <div>
              <Checkbox
                value="Amazing Functionality"
                colorScheme="whiteAlpha"
                mb="2"
                onChange={handleLikesChange}
                isChecked={likes.includes('Amazing Functionality')}
              >
                Amazing Functionality
              </Checkbox>
            </div>
            <div>
              <Checkbox
                value="Great Project and User Experience"
                colorScheme="whiteAlpha"
                mb="2"
                onChange={handleLikesChange}
                isChecked={likes.includes('Great Project and User Experience')}
              >
                Great Project and User Experience
              </Checkbox>
            </div>
          </FormControl>
          <FormControl as="fieldset" mt="4">
            <FormLabel as="legend">What can we improve?</FormLabel>
            <div>
              <Checkbox
                value="Add More Interactive Elements"
                colorScheme="whiteAlpha"
                mb="2"
                onChange={handleImprovementsChange}
                isChecked={improvements.includes('Add More Interactive Elements')}
              >
                Add More Interactive Elements
              </Checkbox>
            </div>
            <div>
              <Checkbox
                value="Optimize for Faster Load Times"
                colorScheme="whiteAlpha"
                mb="2"
                onChange={handleImprovementsChange}
                isChecked={improvements.includes('Optimize for Faster Load Times')}
              >
                Optimize for Faster Load Times
              </Checkbox>
            </div>
          </FormControl>
          <FormControl mt="4">
            <FormLabel>Additional feedback</FormLabel>
            <textarea
              className="rounded-lg w-full h-32 p-2 bg-opacity-25 bg-white text-white placeholder-white placeholder-opacity-50 focus:outline-none"
              value={additionalFeedback}
              onChange={handleAdditionalFeedbackChange}
              required
            ></textarea>
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="whiteAlpha" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button ml="4" colorScheme="green" onClick={handleSubmit} isLoading={loading}>
            {loading ? 'Submitting...' : 'Submit'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default Feedback;
